import React, { useEffect, useState } from 'react'
import { Text, View } from '@react-pdf/renderer'
import { DepartmentController } from '@evertel/department'
import { useService } from '@evertel/di'
import { APIDataDepartment } from '@evertel/types'


const DocumentHeader = ({
    departmentId,
    documentName
}: { departmentId: number, documentName: string}) => {

    const deptController = useService(DepartmentController, [departmentId])
    const [department, setDepartment] = useState<APIDataDepartment>({})

    useEffect(() => {
        (async () => {
            await deptController.init(
                departmentId
            )

            setDepartment(deptController.department)
        })()
    }, [departmentId])

    useEffect(() => {
        setDepartment(deptController.department)
    }, [deptController.department])

    return (
        <View style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'black',
            padding: 8,
            marginBottom: 20
        }}>
            {/* <Image
                src={'https://eadn-wc01-5964675.nxedge.io/wp-content/uploads/2022/09/RandomSuccessatInnovation-SocialGraphic01-760x394.jpg'}
                style={{
                    width: 200,
                    height: 200,
                    objectFit: 'contain'
                }}
            /> */}
            <Text style={{
                fontSize: 16,
                fontWeight: 'bold',
                color: 'white'
            }}>
                {documentName}
            </Text>
            <Text style={{
                fontSize: 12,
                fontWeight: 'bold',
                color: 'white'
            }}>
                {department?.name}
            </Text>
        </View>
    )
}

export default DocumentHeader
